import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@app/services';
import { TranslateService } from '@ngx-translate/core';
import { AbstractSettingsComponent } from '../../abstract-settings';

@Component({
    standalone: false,
    selector: 'app-understand-colors',
    templateUrl: './understand-colors.component.html',
    styleUrls: ['./understand-colors.component.scss'],
})
export class UnderstandColorsComponent extends AbstractSettingsComponent {
    constructor(
        auth: AuthService,
        router: Router,
        route: ActivatedRoute,
        public translateService: TranslateService
    ) {
        super(auth, router, route);
    }
}
